/* eslint-disable jsx-a11y/anchor-is-valid */

import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { FaBars } from 'react-icons/fa';
import Avatar from '../components/avatar';
import {
  getTheme, getMyAccounts, getMyAccount, getUserMeta, getMyProfile, whoAmI, getArtistMeta, getContracts,
} from '../api/queries';

import Loading from './loading';
import {
  logout, sendEvent, sendProperty, themeVariables,
} from '../helpers/helpers';
import AppState from '../store/appstate';
import UserDropDown from '../components/userDropDown';
import NavItems from '../components/navItems';
import Spacer from '../components/spacer';
// import LanguageSelector from '../components/languageSelector';
import { updateMyProfile } from '../api/mutations';

function Layout(props) {
  const { children } = props;
  const [menu, setMenu] = useState(false);
  const [showContractModal, setShowContractModal] = useState(false);
  const history = useHistory();
  const location = useLocation();

  const userMeta = getUserMeta();
  const who = whoAmI();
  const createProfileMutation = updateMyProfile();

  const myAccounts = getMyAccounts();
  const noAccounts = (myAccounts.isSuccess && (myAccounts.data === null || myAccounts.data === undefined || myAccounts.data === 'undefined'));

  const newUser = userMeta.isSuccess && noAccounts && (userMeta.data === 'undefined' || userMeta.data === undefined || userMeta.data === null);
  const selectedAccount = AppState.useState((s) => s.selectedAccount);
  const hubspotProps = AppState.useState((s) => s.hubspot);

  const myAccount = getMyAccount({
    artistaccountcode: selectedAccount,
  });

  const artistMeta = getArtistMeta({
    aac: selectedAccount,
  });

  const contracts = getContracts({
    artistaccountcode: selectedAccount,
  });

  useEffect(() => {
    if (contracts?.data?.results?.length > 0) {
      setShowContractModal(true);
    }
  }, [contracts]);

  const profile = getMyProfile();

  const theme = getTheme({
    cataloguecode: myAccount?.data?.cataloguecode,
  });

  useEffect(() => {
    setMenu(false);
  }, [location]);

  useEffect(() => {
    if (userMeta.isSuccess && myAccounts.isSuccess) {
      if (newUser) {
        history.push('/onboarding-1');
        sendProperty({ property: 'sign_up_date', value: 'CURRENT_DATE', email: who?.data?.email });

        sendProperty({ property: 'sign_up_domain', value: window.location.hostname, email: who?.data?.email });

        if (window.location.hostname.includes('electronic.')) {
          sendEvent({ property: 'pe14489857_b2a_se_sign_up' });
        }

        if (window.location.hostname.includes('music.')) {
          sendEvent({ property: 'pe14489857_sign_up_date' });
        }
      }
      if (noAccounts && !newUser) {
        history.push('/add-account-1');
      }
    }
  }, [userMeta, myAccounts]);

  useEffect(() => {
    if (selectedAccount) {
      myAccount.refetch();
      theme.refetch();
    }
  }, [selectedAccount]);

  // use new end-point to update user address and name etc
  useEffect(() => {
    if (who.isSuccess && profile.isSuccess && userMeta.isSuccess && userMeta.data !== null && profile.data !== null && profile.data !== undefined && profile.data !== 'undefined') {
      if (!profile.data.countrycode) {
        createProfileMutation.reset();
        const data = {
          firstname: who.data.firstname,
          lastname: who.data.lastname,
          addressline1: userMeta.data.address_1,
          addressline2: userMeta.data.address_2,
          addressline3: null,
          towncity: userMeta.data.town,
          countystate: userMeta.data.county,
          postzipcode: userMeta.data.postcode,
          phonenumber: null,
          countrycode: userMeta.data.country,

        };
        createProfileMutation.mutate(data, {
          onSuccess: () => {
            profile.refetch();
          },
          // onError: (error) => {
          //   console.log(error);
          // },
        });
      }
    }
  }, [profile.isSuccess, userMeta.isSuccess, who.isSuccess]);

  useEffect(() => {
    if (who.isSuccess && who.data !== undefined && who.data !== 'undefined' && who.data !== null) {
      if (!hubspotProps?.last_login_date) {
        sendProperty({ property: 'last_login_date', value: 'CURRENT_DATE', email: who.data.email });
        AppState.update((s) => { s.hubspot.last_login_date = true; });
      }
      sendEvent({ property: 'pe14489857_portal_login' });
    }
  }, [who.isSuccess]);

  useEffect(() => {
    if (myAccounts?.data?.artistaccounts && !selectedAccount) {
      AppState.update((s) => { s.selectedAccount = myAccounts?.data?.artistaccounts[0].artistaccountcode; });
    }
  }, [myAccounts]);

  const switchAccount = async (artistaccountcode) => {
    AppState.update((s) => {
      s.selectedAccount = artistaccountcode;
    });
    window.location.reload();
  };

  useEffect(() => {
    const handleEvent = (event) => {
      const { message, data } = event;
      if (data === 'close' || message === 'close') {
        setShowContractModal(false);
        contracts.refetch();
      }
    };

    window.addEventListener('message', handleEvent, false);
    return function cleanup() {
      window.removeEventListener('message', handleEvent);
    };
  }, []);

  useEffect(() => {
    if (myAccount.isSuccess && who.isSuccess) {
      sendProperty({ property: 'artist_name', value: myAccount?.data?.accountname, email: who?.data?.email });
    }
  }, [myAccount.isSuccess, who.isSuccess]);

  useEffect(() => {
    if (artistMeta.isSuccess && who.isSuccess && artistMeta?.data) {
      if (artistMeta?.data?.twitter_obj) {
        const tobj = JSON.parse(artistMeta.data.twitter_obj);
        sendProperty({ property: 'twitterhandle', value: tobj?.data?.username, email: who?.data?.email });
      }

      if (artistMeta?.data?.spotify_obj) {
        const sobj = JSON.parse(artistMeta.data.spotify_obj);
        sendProperty({ property: 'spotify_profile', value: sobj?.external_urls?.spotify, email: who?.data?.email });
      }

      if (artistMeta?.data?.songkick_obj) {
        const skobj = JSON.parse(artistMeta.data.songkick_obj);
        sendProperty({ property: 'songkick_profile', value: skobj?.uri, email: who?.data?.email });
      }

      if (artistMeta?.data?.facebook_obj) {
        sendProperty({ property: 'facebook_page_url', value: artistMeta?.data?.facebook_obj, email: who?.data?.email });
      }
      if (artistMeta?.data?.instagram_obj) {
        sendProperty({ property: 'instagram', value: artistMeta?.data?.instagram_obj, email: who?.data?.email });
      }
    }
  }, [artistMeta.isSuccess, who.isSuccess]);

  if (!myAccounts?.data || !theme?.data) {
    return <Loading />;
  }

  const { darkColour, highlightColour } = themeVariables(theme);

  return (
    <div className="page-fade-in relative w-full antialiased bg-sentric-lightest-gray">
      <div className="flex flex-row flex-wrap lg:flex-nowrap min-h-screen flex-grow">
        <div
          style={{ backgroundColor: darkColour }}
          className="w-full lg:w-60 text-white flex-shrink-0 fixed lg:relative z-30"
        >
          <div style={{ backgroundColor: darkColour }} className="flex flex-col w-full lg:w-60 fixed">
            <div className="flex items-center h-20 align-center justify-center lg:mt-8 lg:mb-8">
              {theme?.data?.logo && (
                <img className="h-12" src={theme.data.logo} alt="logo" />
              )}
            </div>
            <nav className="sidenav hidden lg:block h-screen-minus-side-header md:overflow-y-auto">
              <NavItems
                darkColour={darkColour}
                highlightColour={highlightColour}
                enableOpportunities={theme?.data?.enable_opportunities}
                enableSyncs={theme?.data?.enable_syncs}
                enableStatements={theme?.data?.enable_statements}
                enableRoyalties={theme?.data?.enable_royalties}
              />
            </nav>
          </div>
        </div>
        <div className="mt-20 lg:mt-0 w-full">

          <div className="text-sentric-text-gray bg-white h-16 flex flex-row items-center justify-between lg:justify-end border-b border-sentric-border-gray fixed lg:px-8  w-full lg:w-full-minus-nav z-30">
            <button onClick={() => setMenu(!menu)} type="button" className=" lg:hidden flex items-center p-3 outline-none focus:outline-none">
              <FaBars className="mr-2" />
              {' '}
              Menu
            </button>
            {/* <LanguageSelector /> */}
            {myAccount?.data?.accountname
              && (
                <div className="flex border-l lg:h-full items-center border-sentric-border-gray lg:px-4">
                  <Avatar data={myAccount.data} />
                  <UserDropDown
                    highlightColour={highlightColour}
                    theme={theme}
                    switchAccount={switchAccount}
                    accounts={myAccounts.data}
                    logout={logout}
                    data={myAccount.data}
                    selectedAccount={selectedAccount}
                  />
                </div>
              )}

          </div>
          {menu
            && (
              <div className="top-36 z-40 fixed w-full min-h-screen" style={{ backgroundColor: darkColour }}>
                <div className="h-screen-minus-header overflow-y-scroll">
                  <Spacer />
                  <NavItems
                    darkColour={darkColour}
                    highlightColour={highlightColour}
                    enableOpportunities={theme?.data?.enable_opportunities}
                    enableSyncs={theme?.data?.enable_syncs}
                    enableStatements={theme?.data?.enable_statements}
                    enableRoyalties={theme?.data?.enable_royalties}

                  />
                  <Spacer />
                  <Spacer />
                  <Spacer />

                </div>

              </div>
            )}
          <div className="mt-16 pb-24 lg:pb-0 text-sentric-dark-gray bg-sentric-content-white">{children}</div>
        </div>
      </div>
      {showContractModal && contracts?.data?.results?.length && (
        <div className="z-50 w-full h-full fixed bg-black top-0 left-0 flex justify-center">
          <div className="w-full bg-white h-full">
            <iframe width="100%" height="100%" title="sign contract" src={`https://contracts-uat.sentricapp.com/sign/${contracts.data.results[0].code}?exit=1`} frameBorder="0" style={{ height: '100%' }} />
          </div>
        </div>
      )}
    </div>
  );
}
export default Layout;
